import React from "react";
import { Form, Input, Button, Row, Col, Typography } from "antd";
import { useParams } from "react-router-dom";
import { CreateUserPayload } from "../api";
import { ErrorMessage } from "../components/ErrorMessage";
import { useAuth } from "../hooks/useAuth";
import logo from "../assets/logo.png";

export const CreateUserPassword = () => {
  const { token } = useParams<{ token: string }>();
  const { createPassword } = useAuth();

  const onFinish = (values: CreateUserPayload) => {
    createPassword.mutate({ ...values, token });
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="p-10 background">
      <Row justify="center" align="middle" className="mt-10">
        <Col xs={24} md={12} lg={8}>
          <div
            style={{ backgroundColor: "white", padding: 50, borderRadius: 16 }}
          >
            <div>
              <img src={logo} alt="logo" />
            </div>
            <Typography.Title level={3} className="mt-4">
              Complete your registration
            </Typography.Title>
            <div className="mb-6" />
            <ErrorMessage
              isError={createPassword.isError}
              message="An error occurred"
              className="mb-5"
            />
            <Form
              layout="vertical"
              name="createUserPassword"
              initialValues={{}}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
            >
              <Form.Item
                label=""
                name="name"
                rules={[
                  { required: true, message: "Please enter your username!" },
                ]}
              >
                <Input
                  placeholder="Username"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>

              <Form.Item label="" name="street1" rules={[{ required: true }]}>
                <Input
                  type="text"
                  placeholder="Street 1"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>

              <Form.Item label="" name="street2" rules={[{ required: false }]}>
                <Input
                  type="text"
                  placeholder="Street 2"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>

              <Form.Item label="" name="city" rules={[{ required: true }]}>
                <Input
                  type="text"
                  placeholder="City"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>

              <Form.Item label="" name="zip_code" rules={[{ required: true }]}>
                <Input
                  type="text"
                  placeholder="Zip code"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>

              <Form.Item label="" name="state" rules={[{ required: true }]}>
                <Input
                  type="text"
                  placeholder="State"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>

              <Form.Item label="" name="country" rules={[{ required: true }]}>
                <Input
                  type="text"
                  placeholder="Country"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>

              <Form.Item label="" name="phone" rules={[{ required: true }]}>
                <Input
                  type="tel"
                  placeholder="Phone"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>

              <Form.Item
                label=""
                name="password"
                rules={[
                  { required: true, message: "Please enter your password!" },
                ]}
              >
                <Input.Password
                  placeholder="Password"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>
              <Form.Item
                label=""
                name="confirmpassword"
                rules={[
                  { required: true, message: "Please enter your password!" },
                ]}
              >
                <Input.Password
                  placeholder="Confirm Password"
                  size="large"
                  style={{ borderRadius: 8 }}
                />
              </Form.Item>

              <Form.Item>
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  loading={createPassword.isLoading}
                  className="mt-2"
                  style={{ height: 50, borderRadius: 8, fontWeight: 600 }}
                >
                  Create Password
                </Button>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};
